export default class QuestionModel {
    constructor({id, question, is_active, language, created_by, created_by_name}) {
        this.id = id;
        this.question = question;
        this.language = language;
        this.status = is_active;
        this.created_by = created_by;
        this.created_by_name = created_by_name;
    }
}